export default __webpack_public_path__ + "ultimate-champion-desktop-19520fc6d7c94350d93a4fc41b0198be.png";